import React, { useState } from 'react';
import PageHeader from '../components/PageHeader.jsx';
import ModelTab1 from '../components/ModelTab1.jsx';
import ModelTab2 from '../components/ModelTab2.jsx';
import ModelTab3 from '../components/ModelTab3.jsx';
import '../styles/fonts.css';
import '../styles/model.css';

const Model = () => {
    let SoftwareImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';

    const [activeTab, setActiveTab] = useState('tab1');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div>
            <PageHeader img={SoftwareImg} title="Model" />
            <div className="mt-2 text-gray-700 px-8 py-4 bg-pink-50 border-2 border-[#C94C67] rounded-lg max-w-4xl mx-auto">
                <p>
                    Welcome to our models! We will introduce three models that we developed for our project. The first model is a SEI-SEIR (Susceptible-Exposed-Infectious-Recovered) epidemiological model that completely simulates the dynamics of dengue fever transmission. We used a system of 10 differential equations to predict human and mosquito behavior after implementation of our sticky ovitraps with synbiotic larvicidal toxins. The second one starts with a homology model that predicts the protein structures of our recombinant toxins, a prediction on the synergetic effects of the toxins follows where we provide the Wetlab team critical values before their larvicidal assays. Finally, our third model optimizes the implementation timing for our sticky ovitraps for the maximum impact, fitting our model results to the 2023 official CDC dengue cases. Explore our efforts below to find out more!
                </p>
            </div>

            {/* Tab buttons centered */}
            <div className="flex justify-center">
                <div className="border-gray-200">
                    <div className="flex justify-center space-x-4 p-[25px] relative">
                        {/* Tab Buttons */}
                        <button
                            className={`relative py-4 px-4 text-xs md:text-lg transition-colors duration-300 ease-in-out ${activeTab === 'tab1' ? 'text-[#C94C67] border-brown-600' : 'text-gray-600 border-transparent'} border-b-2 hover:border-[#C94C67] focus:bg-[#e2c6cc] rounded-xl border-[#C94C67]`}
                            onClick={() => handleTabClick('tab1')}
                        >
                            Epidemiological Model
                            {/* Arrow */}
                            {activeTab === 'tab1' && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[72px]">
                                    <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[15px] border-t-[#C94C67]" />
                                </div>
                            )}
                        </button>
                        <button
                            className={`relative py-4 px-4 text-xs md:text-lg transition-colors duration-300 ease-in-out ${activeTab === 'tab2' ? 'text-[#C94C67] border-brown-600' : 'text-gray-600 border-transparent'} border-b-2 hover:border-[#C94C67] focus:bg-[#e2c6cc] rounded-xl border-[#C94C67]`}
                            onClick={() => handleTabClick('tab2')}
                        >
                            Synergistic Effect of Recombinant Toxins
                            {/* Arrow */}
                            {activeTab === 'tab2' && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[72px]">
                                    <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[15px] border-t-[#C94C67]" />
                                </div>
                            )}
                        </button>
                        <button
                            className={`relative py-4 px-4 text-xs md:text-lg transition-colors duration-300 ease-in-out ${activeTab === 'tab3' ? 'text-[#C94C67] border-brown-600' : 'text-gray-600 border-transparent'} border-b-2 hover:border-[#C94C67] focus:bg-[#e2c6cc] rounded-xl border-[#C94C67]`}
                            onClick={() => handleTabClick('tab3')}
                        >
                            Implementation Timing
                            {/* Arrow */}
                            {activeTab === 'tab3' && (
                                <div className="absolute left-1/2 transform -translate-x-1/2 bottom-[72px]">
                                    <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[15px] border-t-[#C94C67]" />
                                </div>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Tab content */}
            <div className="p-4">
                {activeTab === 'tab1' && <ModelTab1 />}
                {activeTab === 'tab2' && <ModelTab2 />}
                {activeTab === 'tab3' && <ModelTab3 />}
            </div>
        </div>
    );
};

export default Model;
